export class AccessibleMenu {

  constructor(selector) {

    this.menu = document.querySelector(selector);

    if (!this.menu) return;

    this.triggers = this.menu.querySelectorAll('.js-submenu-ctrl');
    this.init();

  }

  init() {
    this.bindEvents();
  }

  bindEvents() {

    this.triggers.forEach(trigger => {
      trigger.addEventListener(
        'click',
        this.handleTriggerClick.bind(this)
      );
    });

    document.addEventListener(
      'click',
      this.handleOutsideClick.bind(this)
    );

    document.addEventListener(
      'keydown',
      this.handleEscape.bind(this)
    );

  }

  handleTriggerClick(event) {
    const trigger = event.currentTarget;
    const expanded = trigger.getAttribute('aria-expanded') === 'true';

    this.closeAllMenus();

    if (!expanded) {
      this.openMenu(trigger);
    }
  }

  openMenu(trigger) {
    const submenu = this.getSubmenu(trigger);

    trigger.setAttribute(
      'aria-expanded',
      'true'
    );

    submenu.hidden = false;
    submenu.classList.add('is-open');
  }

  closeMenu(trigger) {
    const submenu = this.getSubmenu(trigger);

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

    submenu.hidden = true;
    submenu.classList.remove('is-open');
  }

  closeAllMenus() {
    this.triggers.forEach(trigger => {
      this.closeMenu(trigger);
    });
  }

  getSubmenu(trigger) {
    const submenuId = trigger.getAttribute('aria-controls');
    return document.getElementById(submenuId);
  }

  handleOutsideClick(event) {
    if (!event.target.closest('#js-nav')) {
      this.closeAllMenus();
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.closeAllMenus();
    }
  }

}